module.exports = __webpack_public_path__ + "static/media/icon-trash-desktop.a4057e53.svg";